import { useState, useEffect, useRef, useCallback } from 'react';

const usePolling = config => {
  let { fetchFunc, delay = 10000 } = config;
  const [isPolling, setIsPolling] = useState(false);
  const refPollingInterval = useRef(null);

  const startPolling = useCallback(() => {
    clearInterval(refPollingInterval.current);
    refPollingInterval.current = setInterval(fetchFunc, delay);
    setIsPolling(true);
  }, [fetchFunc, delay]);

  const cancelPolling = useCallback(() => {
    clearInterval(refPollingInterval.current);
    setIsPolling(false);
  }, []);

  const handleVisibilityChange = useCallback(() => {
    if (!document.hidden) {
      fetchFunc();
      startPolling();
    } else {
      cancelPolling();
    }
  }, [fetchFunc, startPolling, cancelPolling]);

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    startPolling();
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      cancelPolling();
    };
  }, [handleVisibilityChange, cancelPolling, startPolling]);

  return {
    startPolling,
    cancelPolling,
    isPolling
  };
};

export default usePolling;
